import { render } from "./FleetResources.vue?vue&type=template&id=5c27fe0f"
import script from "./FleetResources.vue?vue&type=script&lang=js"
export * from "./FleetResources.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__